'use strict';

 angular.module('config', [])

.constant('ENV', {
    name:'production',
    gigyaApiKey:'3_kzOlN2QEF1QU1vfBPwfdgZejm96Kr1GTd0LZHCulD8DbT_smbSMcerAHTPKvo9Wi',
    apiEndpoint:'https://proapi.zoetispetcare.com:443',
    tokenApiEndpoint: 'https://proproxyapi.zoetispetcare.com:443',
    pwrRoot:'https://petwellnessreport.com:443',
    careplanner_urls: {
        default:'https://careplannerapp.amdevel.com:/{pet_id}/?isPro=true&token={baton}',
        pet_settings:'https://careplannerapp.amdevel.com:/Pets/{pet_id}/?token={baton}',
        clinic_settings:'https://careplannerapp.amdevel.com:/Clinic/{org_id}/?token={baton}'
    },
    proURL:'https://pro.zoetispetcare.com:443',
    newCardReward:'560772',
    refillCardReward:'560773',
    courageDonationReward:'558136',
    orderCardActivity:'410059164',
    pointConversionFactor:'10',
    sfmcStoriesSearchURL: 'https://sfmc-search.search.windows.net',
    sfmcStoriesSearchApiKey: 'AAE2038457A848DC4A4220AB8F2A1DB2',
    sfmcAssetsBaseUrl: 'https://sfmc.zoetispetcare.com',
    sfmcAssetsApiKey: 'vKzkCI48O0qW7hqisqfS5g==',
    contentStackProxyUrl: 'https://api.zoetispetcare.com'
});
